export default {"src":"/_next/static/image/src/assets/images/dropdown-icon.55bf0187341d1bbd29d4369d8f7f0c0f.svg","height":16,"width":16};